export const setLoading = bool => {
  return {
    type: 'LOADING',
    payload: bool
  }
}
